// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FfX3","field":"styles_field__3lDWN","fieldCol":"styles_fieldCol__2wMNi","diffCol":"styles_diffCol__2qEIh","diff":"styles_diff__2S2Bj"};